<template>
  <v-container class="px-0 pt-0 mt-0" v-if="lens" no-gutters>
    <v-row justify="center" no-gutters>
      <v-col cols="12">
        <v-card
          elevation="0"
          class="detailHeader d-flex flex-column flex-sm-row flex-wrap pa-2 align-sm-center justify-center justify-sm-start"
        >
          <div class="imgDivSize my-1 mx-auto mx-sm-0">
            <product-image
              :fileString="lens.image"
              type="scl"
              :maxHeight="95"
              :maxWidth="200"
              class=""
            />
          </div>

          <div class="text-center">
            <div class="">
              <span class="text-h4">{{ lens.name }}</span>
            </div>
          </div>
          <div class="mx-auto mt-2">
            <product-image
              v-if="lens && lens.company_id"
              type="companyId"
              :companyId="parseInt(lens.company_id)"
              :maxHeight="60"
              :maxWidth="150"
              class=""
            />
            <!-- <v-img :src="companyImage"></v-img> -->
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="12" md="8">
        <v-card flat class="cardContent">
          <div class="cardTitle">Parameters</div>
          <soft-power-grid
            :powers="paramArray"
            :additionalFields="additionalFields"
            class="mx-1"
          />
        </v-card>
        <v-card v-if="lens.other_info != ''" flat class="my-4 cardContent">
          <div class="cardTitle">More Info</div>
          <v-card flat class="ma-2 whiteSection">
            <v-card-text class="darkerCardText">
              <vue-markdown class="mdContent">{{
                lens.other_info
              }}</vue-markdown>
            </v-card-text>
          </v-card>
          <div style="height: 0.5em"></div>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <v-card flat class="cardContent">
          <div class="cardTitle">Attributes</div>

          <v-simple-table class="dataTable ma-2 whiteSection">
            <template v-slot:default>
              <tbody>
                <tr>
                  <td>Replacement</td>
                  <td class="caption align-center">6 months</td>
                </tr>
                <tr>
                  <td>Quantity</td>
                  <td>2 vials</td>
                </tr>
                <tr>
                  <td>Wear Type</td>
                  <td>Daily Wear</td>
                </tr>
                <tr>
                  <td>Approved for Extended Wear</td>
                  <td><check-or-minus val="no" /></td>
                </tr>
                <tr>
                  <td>Skirt Polymer</td>
                  <td>
                    <div>
                      {{
                        lens.polymer.pn_poly_name
                          ? lens.polymer.pn_poly_name
                          : ""
                      }}
                    </div>
                    <div v-if="lens.polymer.pn_h2o" class="caption">
                      {{ parseInt(lens.polymer.pn_h2o) }}% water
                    </div>
                    <div v-if="lens.polymer.pn_poly_dk" class="caption">
                      dK {{ lens.polymer.pn_poly_dk }}
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>RGP Polymer</td>
                  <td>
                    {{ lens.rgp_polymer ? lens.rgp_polymer : "" }}
                  </td>
                </tr>

                <tr v-if="lens.website">
                  <td colspan="2">
                    <a :href="lens.website" target="_blank">
                      <v-icon color="primary" class="mr-2">mdi-web</v-icon>
                      Lens Website
                    </a>
                  </td>
                </tr>
                <tr v-if="lens.fitting_guide">
                  <td colspan="2">
                    <a
                      :href="'https://www.eyedock.com/' + lens.fitting_guide"
                      target="_blank"
                    >
                      <v-icon color="primary" class="mr-2"
                        >mdi-file-pdf-box</v-icon
                      >
                      Fitting Guide or Package Insert
                    </a>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
          <div style="height: 0.5em"></div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
  <!-- {{ lens }} -->
</template>

<script>
import ProductImage from "./ProductImage.vue";
import VueMarkdown from "@adapttive/vue-markdown";
import CheckOrMinus from "@/components/universalStuff/CheckOrMinus";
import SoftPowerGrid from "@/components/clStuff/SoftPowerGrid";

// import ClCompanyMixin from "@/assets/js/cls/ClCompanyMixin";

import Slugify from "slugify";

export default {
  name: "HybridDetails",
  components: {
    ProductImage,
    VueMarkdown,
    CheckOrMinus,
    SoftPowerGrid,
  },
  mixins: [],
  props: {
    lens: null,
  },
  data: function () {
    return {
      //   additionalFields: null,
    };
  },

  computed: {
    // companyImage: function () {
    //   if (!this.lens?.company_id) return null;
    //   let obj = this.companyObjForId(this.lens.company_id);
    //   return obj && obj.image ? obj.image : null;
    // },
    additionalFields: function () {
      if (!this.lens) return null;
      let l = this.lens;
      let af = [];
      ["1", "2", "3"].forEach((num) => {
        let field = "label" + num;
        let fieldVal = field + "_values";
        // console.log(field, fieldVal);
        // console.log(l);
        if (l[field] && l[fieldVal]) {
          let key = Slugify(l[field].toLowerCase());
          af.push({ key: key, label: l[field], value: this.lens[fieldVal] });
        }
      });
      //   console.log(af);
      return af.length ? af : null;
    },
    paramArray: function () {
      if (!this.lens) return null;
      let obj = {};
      let l = this.lens;
      obj.sphere = l.sphere;
      obj.diameter = l.diameter;
      if (l.addPwr) obj.addPwr = l.addPwr;
      if (l.curvature_type == "bc") obj.baseCurve = l.curvatures;
      if (l.curvature_type == "vault") obj.vault = l.curvatures;
      if (this.additionalFields) {
        this.additionalFields.forEach((af) => {
          obj[af.key] = af.value;
        });
      }

      return [obj];
    },
    // companyInfo: function () {
    //   // todo - make the server side script return this info (as well as the polymer info)
    //   if (!this.lensData.comp_id) return {};
    //   let companyData =
    //     this.$store.getters.companiesById[this.lensData.comp_id];
    //   return companyData;
    // },
  },
  methods: {
    gitSluggy(val) {
      return Slugify(val.toLowerCase());
    },
  },
};
</script>

<style scoped>
.imgDivSize {
  width: 300px;
  height: 150;
}
.detailHeader {
  border: 1px solid #6e899d;
  min-height: 100px;
  background-image: linear-gradient(138deg, #f9feff 40%, #b9d5e9);
}
.cardContent {
  border: 1px solid #c5c5c5;
  margin: 0 0px;
  /* box-shadow: 2px 3px 5px 1px #80808014 !important; */
}

.cardTitle {
  /* color: #4d4d4d; */
  background-color: #e8f2f9;
  border: 1px solid #a5c3d8;
  margin: -1px -1px;
  box-shadow: 0px 3px 5px 1px #80808014 !important;
}
</style>
